import { EProjectSection, trackEventV2 } from '../trackEventV2';
import { ECampgroundEventName, ICampgroundViewed } from './types';

export function trackCampgroundPageViewed(event: ICampgroundViewed) {
  trackEventV2(ECampgroundEventName.CAMPGROUND_PAGE_VIEWED, EProjectSection.MARKETPLACE, {
    ...event,
  });
}
